






import { Component, Prop, Vue } from 'vue-property-decorator';
import Surface from '@/components/atoms/Surface/Surface.vue';

@Component({ components: { Surface } })
export default class TableFilters extends Vue {
  @Prop({ default: 'auto' }) readonly minWidth?: string;
}
